// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"768dc662","513":"bbbef284","703":"acf44a88"}[chunkId] + ".chunk.js";
};